import React from "react";
import Icon from "components/Icon";
import classNames from "classnames";
import PropTypes from "prop-types";
import { levelTypes } from "domain/Directories/types";

const ConditionsSecond = ({ mods = [], level, genderName, isPublic }) => {
    return (
        <div
            className={classNames(
                `card-full__conditions-second`,
                mods.map((mod) => `${mod}`)
            )}
        >
            <ul className="conditions card-full__block">
                <li className="conditions__item">
                    <span className="conditions__icon-container icon-container">
                        <Icon type={`view`} inheritColor />
                    </span>

                    <div className="conditions__right-col">
                        <p className={`fs-body1`}>
                            {isPublic ? "Публичная" : "Приватная"} игра
                        </p>
                    </div>
                </li>

                <li className="conditions__item">
                    <span className="conditions__icon-container icon-container">
                        <Icon type={`star`} inheritColor />
                    </span>

                    <div className="conditions__right-col">
                        <p className={`fs-body1`}>{level?.name}</p>
                    </div>
                </li>

                <li className="conditions__item">
                    <span className="conditions__icon-container icon-container">
                        <Icon type={`user`} inheritColor />
                    </span>

                    <div className="conditions__right-col">
                        <p className={`fs-body1`}>{genderName}</p>
                    </div>
                </li>
            </ul>
        </div>
    );
};

ConditionsSecond.propTypes = {
    mods: PropTypes.arrayOf(PropTypes.string),
    level: levelTypes,
    genderName: PropTypes.string,
    isPublic: PropTypes.bool,
};

export default ConditionsSecond;
